import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import { Chip as MuiChip, ChipProps as MuiChipProps } from '@mui/material';
import React from 'react';

import { toSxArray } from '_lib/utils/helpers';

export type ChipProps = Omit<MuiChipProps, 'deleteIcon'>;

export const Chip = (props: ChipProps) => {
  const { onDelete, sx, ...restOfProps } = props;
  return (
    <MuiChip
      deleteIcon={onDelete ? <DeleteOutlineIcon color='error' /> : undefined}
      onDelete={onDelete}
      sx={[
        (theme) =>
          onDelete && {
            '& .MuiChip-deleteIcon': {
              color: theme.palette.error.main
            },
            '& .MuiChip-deleteIcon:hover': {
              color: theme.palette.error.dark
            }
          },
        ...toSxArray(sx)
      ]}
      {...restOfProps}
    />
  );
};
